<template>
  <div class="print-previous-replies">
    <qaim-evaluation
      v-if="requestObjectKey && requestSimpleInfo"
      :request-evaluations-code="qaimEvaluationCode"
      :ref-num="requestObjectKey"
      :is-lawsuit-request="true"
      :header-text="surveyHeaderText"
    >
    </qaim-evaluation>
    <printing-page>
      <papers-header title="تذكرة مراجعة"></papers-header>
      <paper>
        <lawsuit-ticket :request-object-key="requestObjectKey"></lawsuit-ticket>
      </paper>

      <papers-footer></papers-footer>
      <action></action>
    </printing-page>

    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PrintingPage from '@/components/printing/page.vue';
import Paper from '@/components/printing/paper.vue';
import PapersHeader from '@/components/printing/header.vue';
import PapersFooter from '@/components/printing/footer.vue';
import Action from '@/components/printing/action.vue';
import qaimEvaluation from '@/modules/lawsuit/components/qaim-evaluations';
import LawsuitTicket from '../components/lawsuit-ticket/index.vue';
const { mapState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('LawsuitModule');
import { caseCategoryEnum } from '@/helpers/enum';

export default {
  components: {
    PrintingPage,
    Paper,
    PapersHeader,
    PapersFooter,
    Action,
    qaimEvaluation,
    LawsuitTicket,
  },
  data() {
    return { requestSimpleInfo: null };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState({ qaimConfig: state => state.qaimConfig }),
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
    isUrgentCaseCategory() {
      return this.requestSimpleInfo?.caseCategory == caseCategoryEnum.urgentCase;
    },
    qaimEvaluationCode() {
      return this.isUrgentCaseCategory ? this.qaimConfig.requestEvaluationsCodes.urgentCaseLawsuit : this.qaimConfig.requestEvaluationsCodes.newLawsuitRequest;
    },
    surveyHeaderText() {
      return this.isUrgentCaseCategory ? this.local.qaimSurvey.urgentCaseSurveyTitle : '';
    },
  },
  methods: {
    ...mapActions(['getRequestSimpleInfo']),
    getData() {
      this.getRequestSimpleInfo(this.requestObjectKey)
        .then((res) => {
          this.requestSimpleInfo = res?.data;
        });
    },
  },
};
</script>
